module.exports = __webpack_public_path__ + "static/media/chrome.4f65aa82.png";